import MapView, { Location } from "@/shared/components/common/map";
import StackKit from "@/shared/components/kit/stack";
import { useSearchParams } from "react-router";
/**
 * LocationDetailUser
 *
 * نمایش جزئیات موقعیت یک مرکز بر روی نقشه.
 *
 * - دریافت مختصات و نام مرکز از query string با استفاده از `useSearchParams`.
 * - تبدیل داده‌ها به فرمت مورد نیاز `MapView`: `{ name, lat, lng }`.
 * - نمایش نقشه با موقعیت مشخص شده.
 *
 * @returns JSX.Element
 */

const LocationDetailUser = () => {
  const [searchParams] = useSearchParams();
  const lat = searchParams.get("lat");
  const lon = searchParams.get("lon");
  const name = searchParams.get("name");
  let points: Location[] = [];

  if (lat && lon && name) {
    points = [{ name: `${name}`, lat: +lat, lng: +lon }];
  }
  return (
    <StackKit>
      <MapView locations={points} />{" "}
    </StackKit>
  );
};

export default LocationDetailUser;
